// @ts-nocheck

import moment from 'moment-mini';
import CryptoJS from "crypto-js";

/**
 * 验证IP地址
 * @param {*} rule      规则
 * @param {*} value     要验证的值
 * @param {*} callback  验证回调
 */
export function ValidateIP(rule: any, value: any, callback: any) {
    if (value === undefined || value === null || value === "") {
        callback();
    } else {
        if (IsValidIP(value)) {
            callback();
        } else {
            callback(new Error("请输入正确的IP地址"));
        }
    }
}

/**
 * 验证IP
 * @param value
 * @returns
 */
export function IsValidIP(value: string) {
    const reg = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    return reg.test(value);
}

/**
 * 验证端口
 * @param port
 * @returns
 */
export function isPort(port: any) {
    return /^[1-9]\d*|0$/.test(port) && port * 1 >= 0 && port * 1 <= 65535;
}

/**
 * 数字左边补0
 * @param num
 * @param n
 * @param substr
 * @returns
 */
export function Pad(num: any, n: any, substr?: boolean) {
    const result = `${Array(n > `${num}`.length ? n - `${num}`.length + 1 : 0).join("0")}${num}`;
    if (substr) {
        return result.substring(0, n);
    } else {
        return result;
    }
}

// 字符集，32进制
const charset = "0123456789ABCDEFGHIJKLMNOPQRSTUV"
const charsetMap = {} as any; // 预构建哈希表加速查找
charset.split('').forEach((c, i) => charsetMap[c] = i);

// 32进制转十进制
function decimalToBase32(n: number) {
    if (n === 0) return '0';
    let s = '';
    while (n > 0) {
        s = charset[n % 32] + s; // 直接字符串拼接
        n = Math.floor(n / 32);
    }
    return s;
}

// 32进制转十进制
export function Base32ToDecimal(s: string) {
    let result = 0;
    for (let i = 0; i < s.length; i++) {
        const c = s[i];
        const idx = charsetMap[c];
        if (idx === undefined) throw new Error(`Invalid character: ${c}`);
        result = result * 32 + idx;
        // 检查是否溢出（Number.MAX_SAFE_INTEGER = 2^53 -1）
        if (result > Number.MAX_SAFE_INTEGER / 32) {
            throw new Error('Value exceeds safe integer range');
        }
    }
    return result;
}

/**
 * 创建Guid
 * @returns
 */
export function CreateGuid(time?: any) {
    if (!time) {
        time = moment();
    }

    const mid = "10000";
    const cate = Pad(decimalToBase32(RndNumber(3)), 2);
    const uid = "M" + Pad(decimalToBase32(RndNumber(8)), 7);//保证最少一位字母
    const ts = Pad(decimalToBase32(time.unix()), 8);
    const seq = Pad(decimalToBase32(RndNumber(3)), 2);
    const rnd = Pad(decimalToBase32(RndNumber(5)), 4);

    // const cate=RndNumber(2).toString();
    // const uid=RndNumber(8).toString();
    // const ts=time.unix().toString();
    // const seq="";
    // const rnd = RndNumber(4).toString();

    const guid = mid + cate + uid + ts + seq + rnd;
    const check = computeCheck(guid);

    return guid + check;
}

// 基准数，最大的3位32进制数值 vvv
const baseNum = 32767

// 计算校验码
function computeCheck(guid: string): string {
    const timeStr = guid.substring(15, 23);
    const timeFromStr = moment.unix(Base32ToDecimal(timeStr));
    if (timeFromStr.isValid()) {
        const mid = parseInt(guid.substring(0, 5));
        const cate = Base32ToDecimal(guid.substring(5, 7));
        const uid = Base32ToDecimal(guid.substring(7, 15));
        const seq = Base32ToDecimal(guid.substring(23, 25));
        const rnd = Base32ToDecimal(guid.substring(25, 28));
        const sum = timeFromStr.year() + (timeFromStr.month() + 1) + timeFromStr.date() +
            timeFromStr.hour() + timeFromStr.minute() + timeFromStr.second() +
            mid + uid +
            cate + seq + rnd;

        let multiple = 1;
        if (sum > baseNum) {
            multiple = Math.ceil(sum / baseNum);
        }
        const check = multiple * baseNum - sum;
        const result = decimalToBase32(check);
        return Pad(result, 3);
    }
    return "";
}

// 转Base64
export function base64Encode(input: any) {
    let rv;
    rv = encodeURIComponent(input);
    rv = unescape(rv);
    rv = window.btoa(rv);
    return rv;
}

//Base64解
export function base64Decode(input: any) {
    let rv = window.atob(input);
    rv = escape(rv);
    rv = decodeURIComponent(rv);
    return rv;
}

// 转义
export function Uint8ArrayToBase64(array: any) {
    array = new Uint8Array(array);
    const length = array.byteLength;
    const table = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "+",
        "/"
    ];
    let base64Str = "";
    let i = 0;
    for (i = 0; length - i >= 3; i += 3) {
        const num1 = array[i];
        const num2 = array[i + 1];
        const num3 = array[i + 2];
        base64Str +=
            table[num1 >>> 2] +
            table[((num1 & 0b11) << 4) | (num2 >>> 4)] +
            table[((num2 & 0b1111) << 2) | (num3 >>> 6)] +
            table[num3 & 0b111111];
    }
    const lastByte = length - i;
    if (lastByte === 1) {
        const lastNum1 = array[i];
        base64Str += `${table[lastNum1 >>> 2]}${table[(lastNum1 & 0b11) << 4]}==`;
    } else if (lastByte === 2) {
        const lastNum1 = array[i];
        const lastNum2 = array[i + 1];
        base64Str += `${table[lastNum1 >>> 2]}${table[((lastNum1 & 0b11) << 4) | (lastNum2 >>> 4)]}${table[(lastNum2 & 0b1111) << 2]}=`;
    }
    return base64Str;
}

/**
 * 校验密码强度
 * @param {string} value 密码
 */
export function CheckPassWordLevel(value: string) {
    // 1： 表示第一个级别 2：表示第二个级别 3：表示第三个级别
    // 4： 表示第四个级别 5：表示第五个级别
    let modes = 1;
    if (value.length < 6) {
        // 最初级别
        return modes;
    }
    if (/\d/.test(value)) {
        // 如果用户输入的密码 包含了数字
        modes++;
    }
    if (/[a-z]/.test(value)) {
        // 如果用户输入的密码 包含了小写的a到z
        modes++;
    }
    if (/[A-Z]/.test(value)) {
        // 如果用户输入的密码 包含了大写的A到Z
        modes++;
    }
    if (/\W/.test(value)) {
        // 如果是非数字 字母 下划线
        modes++;
    }

    return modes;
}

/**
 * 校验手机号有效性
 * @param {*} value     要验证的值
 */
export function CheckMobilePhone(value: any) {
    if (value !== "") {
        const reg = /^1[3456789]\d{9}$/;
        if (!reg.test(value)) {
            return false;
        }
    }
    return true;
}

/**
 * 验证邮政编码
 * @param {*} value     要验证的值
 */
export function CheckPostCode(value: any) {
    if (value !== "") {
        const reg = /^[0-9]{6}$/;
        if (!reg.test(value)) {
            return false;
        }
    }
    return true;
}

/**
 * 验证邮政编码
 * @param rule
 * @param value
 * @param callback
 */
export function ValidatePostCode(rule: any, value: any, callback: any) {
    if (value) {
        if (!CheckPostCode(value)) {
            callback(new Error("请输入正确的邮政编码"));
        } else callback();
    } else callback();
}

/**
 * 验证电话（传真）号码
 * @param {*} value     要验证的值
 */
export function CheckTEL(value: any) {
    if (value !== "") {
        const reg = /(^(\d{3,4}-)?\d{6,8}$)|(^(\d{3,4}-)?\d{6,8}(-\d{1,5})?$)|(\d{11})/;
        if (!reg.test(value)) {
            return false;
        }
    }
    return true;
}

/**
 * 验证电子邮箱格式
 * @param {*} value     要验证的值
 */
export function CheckEMail(value: any) {
    // 检查邮箱格式
    return /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(value);
}

/**
 * 验证可空电子邮箱
 * @param rule
 * @param {*} value     要验证的值
 * @param callback
 */
export function ValidEMail(rule: any, value: any, callback: any) {
    if (value) {
        if (!CheckEMail(value)) {
            callback(new Error("请输入正确的电子邮箱"));
        } else callback();
    } else callback();
    // 检查邮箱格式
}

/**
 * 验证电话（传真）号码
 * @param rule
 * @param value
 * @param callback
 */
export function ValidateTEL(rule: any, value: any, callback: any) {
    if (value) {
        if (!CheckTEL(value)) {
            callback(new Error("请输入正确的电话（传真）号码"));
        } else callback();
    } else callback();
}

/**
 * MD5值
 * @param value
 */
export function MD5(value: string) {
    return CryptoJS.MD5(value).toString().toUpperCase();
}

/**
 * MD5值  混淆9527
 * @param value
 */
export function MD59527(value: string) {
    const pwd = CryptoJS.MD5(value).toString().split("") as any[];
    pwd[9] = String.fromCharCode(pwd[9].charCodeAt() + 9);
    pwd[5] = String.fromCharCode(pwd[5].charCodeAt() + 5);
    pwd[2] = String.fromCharCode(pwd[2].charCodeAt() + 2);
    pwd[7] = String.fromCharCode(pwd[7].charCodeAt() + 7);
    return pwd.join("");
}

/**
 * 格式化时间戳
 * @param value
 * @param format
 */
export function FormatUNIX(value: number, format?: string) {
    if (value && value > 0) {
        if (!format) {
            format = "YYYY-MM-DD HH:mm:ss";
        }
        return moment.unix(value).format(format);
    } else {
        return "-";
    }
}

// 转换函数 YYYY-MM-DD HH:mm 的式格
export function ConvertToTimestamp(timeString: string): number {
    // 正则表达式验证格式
    const regex = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/;
    const match = timeString.match(regex);

    if (!match) {
        return null;
    }

    // 提取年月日时分
    const year = parseInt(match[1], 10);
    const month = parseInt(match[2], 10) - 1; // 月份从0开始
    const day = parseInt(match[3], 10);
    const hours = parseInt(match[4], 10);
    const minutes = parseInt(match[5], 10);

    // 创建Date对象
    const date = new Date(year, month, day, hours, minutes);

    // 验证日期有效性
    if (date.getFullYear() !== year ||
        date.getMonth() !== month ||
        date.getDate() !== day ||
        date.getHours() !== hours ||
        date.getMinutes() !== minutes) {
        return null;
    }

    //只取10位
    return Math.floor(date.getTime() / 1000);
}

export function FormatWeekList(value: string) {
    if (!value || value.length < 1) return ""
    const list = value.split(",");
    let res = ""
    for (let i = 0; i < list.length; i++) {
        const t = FormatWeek(parseInt(list[i], 10));
        if (t) {
            res += (res.length > 0 ? "、" : "") + t;
        }
    }
    return res
}

export function FormatWeek(value: number) {
    if (value < 0 || value > 6) return "";
    const w1 = ["日", "一", "二", "三", "四", "五", "六", "日"];
    return w1[value];
}

//取得当前星期
export function GetNowWeek(): number {
    return new Date().getDay();
}

//取得小数部份
export function GetFractionalPart(value: number) {
    return Math.round((value - Math.trunc(value)) * 100);
}

export function GetTimestamp(): number {
    return Number(new Date());
}

//取得当前日期的时间戳
export function GetNowDate(): number {
    return Math.floor(new Date().setHours(0, 0, 0, 0) / 1000);
}

//时间格式的接口
interface ITime {
    HH: number,//小时部份，0～23
    mm: number,//分钟部份，0～59
}

//取得当前时间
export function GetNowTime(date = new Date()): number {
    const mm: number = date.getMinutes();
    return parseFloat(date.getHours() + '.' + (mm < 10 ? '0' : '') + mm.toString());
}

//把数值型的时间拆解成小时和分钟
export function UnpackFloatTime(time: number): ITime {
    const res: ITime = {
        HH: 0,
        mm: 0,
    };
    if (!time || time == 0 || time == 24 || time < 0 || time > 23.59) {
        return res;
    } else {
        const mm = GetFractionalPart(time);
        if (mm >= 60) {
            res.HH = parseInt(time);
            res.mm = 59;
            return res;
        } else {
            res.HH = parseInt(time);
            res.mm = mm;
            return res;
        }
    }
}

//把数值型时间格式化为：00:00的格式
export function FormatTime(time: number): string {
    if (!time) {
        return "00:00";
    }
    const res = UnpackFloatTime(time);
    if (!res) {
        return "00:00";
    }
    return res.HH.toString().padStart(2, "0") + ":" + res.mm.toString().padStart(2, "0");
}

// ToFloatTime 时间转时间戳
// 注意：如果不是 13:45 格式，则返回0
// 如果小时部份不在 0-23 则小时部份为0
// 如果分钟部份小于0 则分钟部份为0，如果分钟部份大于59 则分钟部份为59
export function ToFloatTime(time: string): number {
    if (!time || time == "" || time.length != 5 || time.indexOf(":") < 0) {
        return 0
    }
    let hh: number = parseInt(time.slice(0, 2));
    let mm: number = parseInt(time.slice(3, 5));
    if (hh < 0 || hh > 23) {
        hh = 0;
    }
    if (mm < 0) {
        mm = 0;
    } else if (mm > 59) {
        mm = 59;
    }
    return hh + mm / 100;
}

/**
 * 检查一个时间是否落在一个时间范围内
 * @param checkTime 要检查的时间
 * @param startTime 开始时间
 * @param endTime 结束时间
 */
export function CheckInTimeRange(checkTime: number, startTime: number, endTime: number): boolean {
    if (checkTime < 0 || checkTime >= 24 || startTime < 0 || startTime >= 24 || endTime < 0 || endTime >= 24) {
        return false
    }
    if (startTime <= endTime) {
        //正常时间段，00:00-23:59
        return checkTime >= startTime && checkTime <= endTime
    } else {
        //跨天时间段，例如：23:00-01:00
        return checkTime >= startTime || checkTime <= endTime
    }
}

/**
 * 格式化金额
 * @param val
 * @param isFen 是否是分
 * @param CNY
 */
function formatMoney(val: any, isFen: boolean, CNY ?: string): string {
    let result = "-";
    if (val || val === 0) {
        val = val.toString().replace(/[$,]/g, "");
        if (isNaN(val)) {
            val = "0";
        }

        const numberVal = Number(val);
        const sign = numberVal < 0 ? "-" : "";
        // 使用绝对值避免负数问题
        if (isFen) {
            //输入金额为fen为单位
            val = Math.floor(Math.abs(numberVal) + 0.50000000001);
        } else {
            //输入金额为元为单位
            val = Math.floor(Math.abs(numberVal) * 100 + 0.50000000001);
        }
        let cents = (val % 100) as any;
        val = Math.floor(val / 100).toString();

        if (cents < 10) {
            cents = `0${cents}`;
        }

        // 优化千分位分隔符逻辑
        for (let i = 0; i < Math.floor((val.length - 1) / 3); i++) {
            val = `${val.substring(0, val.length - (i * 4 + 3))},${val.substring(val.length - (i * 4 + 3))}`;
        }

        let cny = "¥";

        switch (CNY) {
            case "":
            case " ": {
                cny = "";
                break
            }
            case "USD": {
                cny = "$";
            }
        }
        result = `${cny}${sign}${val}.${cents}`;
    }

    return result;
}

/**
 * 格式化显示以分为单位的金额
 * @param val
 * @param CNY
 * @constructor
 */
export function FormatFenMoney(val: any, CNY ?: string): string {
    return formatMoney(val, true, CNY);
}

/**
 * 格式化显示以元为单位的金额
 * @param val
 * @param CNY
 * @constructor
 */
export function FormatYuanMoney(val: any, CNY ?: string): string {
    return formatMoney(val, false, CNY);
}

/**
 * 把以分为单位的金额转成以元为单位的金额
 * @param val
 * @constructor
 */
export function ToYuanMoney(val: number): number {
    if (!val || val <= 0) {
        return 0;
    }
    return val / 100;
}

/**
 * 把以元为单位的金额转成以分为单位的金额
 * @param val
 * @constructor
 */
export function ToFenMoney(val: number): number {
    if (!val || val <= 0) {
        return 0;
    }
    return Math.round(val * 100);
}

/*
 * 格式化折扣
 */
export function FormatRate(val: number): string {
    if (!val || val <= 0 || val >= 100) {
        return "无折扣";
    }
    return (val / 10).toFixed(1) + "折";
}

/** 生成数组 */
export function MakeRange(start: number, end: number) {
    const result: number[] = [];
    for (let i = start; i <= end; i++) {
        result.push(i);
    }
    return result;
}

/**
 * 格式化容量大小
 * @param {*} value 字节
 */
export function FormatSize(value: any) {
    if (value && value > 0) {
        const unitArr = ["Bytes", "KB", "MB", "GB", "TB"];
        let index = 0;
        const srcsize = parseFloat(value);
        index = Math.floor(Math.log(srcsize) / Math.log(1024));
        if (index > 4) {
            index = 4;
        }
        let size = (srcsize / Math.pow(1024, index)) as any;
        size = size.toFixed(2);
        return size + unitArr[index];
    } else {
        return "-";
    }
}

export function clone(json: object) {
    return JSON.parse(JSON.stringify(json));
}

export function SetWebRTCBitrate(sdp: string) {
    const lines = sdp.split("\n");

    lines.forEach((l: string, index: number) => {
        if (l.indexOf(`a=fmtp:`) === 0 && l.indexOf("level-asymmetry-allowed=1;") > 0) {
            lines[index] = `${l};x-google-max-bitrate=2048;x-google-min-bitrate=1024;x-google-start-bitrate=1024`;
        }
    });

    return lines.join("\n");
}

// 筛选条件-报修时间
export const ConditionSymbolList = [
    {
        value: 1,
        label: "大于"
    },
    {
        value: 2,
        label: "大于等于"
    },
    {
        value: 3,
        label: "小于"
    },
    {
        value: 4,
        label: "小于等于"
    },
    {
        value: 5,
        label: "等于"
    },
    {
        value: 6,
        label: "介于"
    }
];

// interface ArrayItem {
//   ID: number;
//   Name: string;
//   ParentID: number;
// }
// // 定义树节点的数据类型，包含id、name、可能存在的子节点
// interface TreeNode {
//   ID: number;
//   Name: string;
//   Children?: TreeNode[]; // 叶子节点没有子节点
// }

// export function tree2Array(root: TreeNode): ArrayItem[] {
//   // 定义子节点和父节点的映射关系，map<子节点，父节点>
//   const childToParent: Map<TreeNode, TreeNode> = new Map();

//   const arr: ArrayItem[] = []; // 返回的数组

//   // 广度优先遍历树，使用队列保存节点
//   const queue: TreeNode[] = [];
//   queue.unshift(root); // 入队，从头部入队
//   while (queue.length) {
//     const curNode = queue.pop(); // 出队，从尾部出队，保证先进先出
//     if (curNode == null) break; // 循环结束，使用==包括了null和undefined的情况

//     const { ID, Name, Children = [] } = curNode; // 结构赋值，叶子节点没有children属性，所以默认为空数组

//     const parentNode = childToParent.get(curNode); // 获取当前节点的父节点
//     const ParentID = parentNode?.ID || 0; // 获取父节点id，根节点设置为0
//     const item = { ID, Name, ParentID }; // 定义数组项
//     arr.push(item); // 插入到数组中 // 继续遍历子节点，并且子节点入队

//     Children.forEach((child) => {
//       // 如果有子节点，则把子节点和当前节点通过Map保持关系
//       childToParent.set(child, curNode); // 入队

//       queue.unshift(child);
//     });
//   }

//   return arr;
// }
interface TreeNode {
    ID: number;
    Name: string;
    Children?: TreeNode[];
}

export function flattenTree(tree: TreeNode[], result: TreeNode[] = []): TreeNode[] {
    for (const node of tree) {
        result.push(node);
        if (node.Children) {
            flattenTree(node.Children, result);
        }
    }
    return result;
}

/**
 * 转换时间格式 年月日
 */
export function FormatDate(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

/**
 * @method
 * @author  gedesiwen
 * @param {array} arr 需要查找的数组
 * @param {number} target 目标数值，查找的是与这个数值最接近的
 * @return {number} 返回查找到的最接近的数值
 * @desc 获取数组中与目标数值最接近的数值
 */
export function findCloseNum(arr: number[], target: number) {
    let mid;
    let l = 0;
    let r = arr.length - 1;
    // 保证指针最终停留在相邻的两个数,所以这里是判断是否大于1
    while (r - l > 1) {
        mid = Math.floor((l + r) / 2);
        // 如果目标数比中间小，所以范围在左边
        if (target < arr[mid]) {
            r = mid;
        } else {
            l = mid;
        }
    }

    // 最后比较这两个数字的绝对差大小即可。
    return Math.abs(target - arr[l]) <= Math.abs(target - arr[r]) ? arr[l] : arr[r];
}

/**
 * @method
 * @param {number} value 秒
 */
export const formatSeconds = (value: any) => {
    let secondTime: any = parseInt(value);
    let minuteTime: any = 0;
    let hourTime: any = 0;
    if (secondTime > 60) {
        minuteTime = (secondTime / 60).toFixed(1).slice(0, -2);
        secondTime = (secondTime % 60).toFixed(1).slice(0, -2);
        if (Number(minuteTime) > 60) {
            hourTime = (Number(minuteTime) / 60).toFixed(1).slice(0, -2);
            minuteTime = (Number(minuteTime) % 60).toFixed(1).slice(0, -2);
        }
    }
    if (Number(secondTime) === 0) {
        secondTime = "00";
    } else if (Number(secondTime) < 10) {
        secondTime = `0${secondTime}`;
    }
    if (Number(minuteTime) === 0) {
        minuteTime = "00";
    } else if (Number(minuteTime) < 10) {
        minuteTime = `0${minuteTime}`;
    } else if (Number(minuteTime) >= 60) {
        minuteTime = "00";
        hourTime = Number(hourTime) + 1;
    }
    if (Number(hourTime) === 0) {
        hourTime = "00";
    } else if (Number(hourTime) < 10) {
        hourTime = `0${hourTime}`;
    }
    return `${hourTime}:${minuteTime}:${secondTime}`;
};

export function timeToSeconds(time: string): number {
    const [hours, minutes, seconds] = time.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
}

export const downloadFile = (urls: string[]) => {
    const willDo: any[] = [];
    urls.forEach((path, index) => {
        const promise = new Promise((resolve) => {
            setTimeout(() => {
                const iframe = document.createElement("iframe") as HTMLIFrameElement;
                iframe.style.display = "none"; // 防止影响页面
                iframe.style.height = "0"; // 防止影响页面
                iframe.src = path;
                document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
                resolve("ok");
                // 5分钟之后删除

                setTimeout(() => {
                    iframe.remove();
                }, 5 * 60 * 1000);
            }, 1000 * index);
        });
        willDo.push(promise);
    });
    Promise.all(willDo).then((result) => {
        console.log("下载结果", result);
    });
};

/**
 * 字符串转json，失败返回字符串
 * @param str
 * @return {any}
 */
export const strConvertJson: any = (str: any): any => {
    try {
        if (typeof JSON.parse(str) === "object") {
            return JSON.parse(str);
        }
    } catch (e) {
    }
    return str;
};
// 默认展开树形所有节点
export const expandAllNodes = (treeData: any) => {
    let result = [] as any;
    treeData.forEach((item: any) => {
        if (item.Children && item.Children.length) {
            result.push(item);
            const childrens = expandAllNodes(item.Children);
            if (childrens && childrens.length) {
                result = result.concat(childrens);
            }
        }
    });
    return result;
};
// 树形数据转成扁平数据
export const treeToArray = (source: any[], key = "Children") => {
    const res: any[] = [];
    source.forEach((el) => {
        res.push(el);
        el[key] && res.push(...treeToArray(el[key]));
    });
    return res;
};
// 防抖函数
export const debounce = <T extends (...args: any) => any>(
    fn: T,
    time?: number,
    immediate?: boolean
): ((...args: any) => any) => {
    let timeoutId: null | number;
    let defaultImmediate = immediate || false;
    const delay = time || 300;
    return (...args: any) => {
        if (defaultImmediate) {
            fn.apply(this, args); // 确保引用函数的指向正确，并且函数的参数也不变
            defaultImmediate = false;
            return;
        }
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            fn.apply(this, args);
            timeoutId = null;
        }, delay);
    };
};

export function secondsToHMS(seconds: number) {
    if (!seconds) {
        return "00:00";
    } else {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = Math.round(seconds % 60);
        let str = "";
        if (hours > 0) {
            str += `${(hours > 9 ? "" : "0") + hours}:`;
        }

        str += `${(minutes > 9 ? "" : "0") + minutes}:${(remainingSeconds > 9 ? "" : "0") + remainingSeconds}`;
        return str;
    }
}

/**
 * 将秒转化成时分秒
 * @param s 秒
 */
export const secondToTimeStr = (s: number): string => {
    let t = "";
    if (s > -1) {
        const hour = Math.floor(s / 3600);
        const min = Math.floor(s / 60) % 60;
        const sec = s % 60;
        t += `${hour < 10 ? "0" : ""}${hour}:${min < 10 ? "0" : ""}${min}:${sec < 10 ? "0" : ""}${sec}`;
    }
    return t;
};

// 毫秒转"00:00:00"格式
export function msToTimeRange(time: number, unit = "ms") {
    let result = "";
    // 如果时间是毫秒
    if (unit === "ms") {
        let count = time;
        // 获取当前时间的小时数
        const hours = Math.floor(count / 1000 / 60 / 60);
        if (hours) {
            result += `${hours}:`;
            count -= hours * 60 * 60 * 1000;
        }
        const mins = Math.floor(count / 1000 / 60);
        if (mins) {
            result += `${mins > 9 ? mins : "0" + mins}:`;
            count -= mins * 60 * 1000;
        } else {
            result += "00:";
        }
        const secs = Math.floor(count / 1000);
        if (secs) {
            result += `${secs > 9 ? secs : `0${secs}`}`;
        } else {
            result += "00";
        }
    }
    return result;
}

// 通过时间戳获取日期
export function numberToDate(number: number, format = "YYYY-MM-DD") {
    return moment.unix(number).format(format);
}

// 验证字符串字节大小
export function BytesCount(str: string) {
    let cnt = 0;
    for (let i = 0; i < str.length; i++) {
        const c = str.charAt(i);
        if (/^[\\x00-\\x7F]$/.test(c)) {
            cnt++;
        } else {
            cnt += 2;
        }
    }

    return cnt;
}

// 检查首字母是否大写
export function IsFirstLetterUppercase(prop: string) {
    return /^[A-Z]/.test(prop);
}

//复制B对象的值给A对象
export function AssignValues(objA: any, objB: any) {
    for (const key of Object.keys(objA)) {
        if (IsFirstLetterUppercase(key)) {
            // 如果属性值是对象，则递归处理
            if (typeof objB[key] === "object" && objB[key] !== null && !Array.isArray(objB[key])) {
                AssignValues(objA[key], objB[key]);
            } else {
                switch (typeof objA[key]) {
                    case 'number':
                        objA[key] = objB[key] ?? 0;
                        break;
                    case 'boolean':
                        objA[key] = objB[key] === 1;
                        break;
                    default:
                        objA[key] = objB[key];
                        break;
                }
            }
        }
    }
}

/**
 * 获取文件名和后缀
 * @param {String} name
 */
export function GetFileExt(name: string) {
    const fileNameWithExtension = name.substring(name.lastIndexOf("/") + 1); // 获取文件名（带后缀）
    const last_len = fileNameWithExtension.lastIndexOf('.')
    const len = fileNameWithExtension.length
    return {
        name: fileNameWithExtension.substring(0, last_len),
        ext: fileNameWithExtension.substring(last_len + 1, len)
    }
}

/**
 * 生成加密安全的随机整数（均匀分布）
 * @param {number} min - 最小值（包含）
 * @param {number} max - 最大值（包含）
 * @returns {number} 位于 [min, max] 范围内的整数
 * @throws {Error} 参数不合法时抛出异常
 */
export function Random(min: number, max: number): number {
    if (min > max) {
        throw new Error('min 不能大于 max');
    }

    // 计算范围
    const range = max - min + 1;
    if (range <= 0 || range > 0xFFFFFFFF) { // 0xFFFFFFFF = 4294967295（4字节最大值）
        throw new Error('无效的范围，请确保 0 < (max - min + 1) ≤ 4294967295');
    }

    // 生成 4 字节随机数据（32位）
    const randomBytes = CryptoJS.lib.WordArray.random(4);
    const uint32 = randomBytes.words[0] >>> 0; // 转换为无符号32位整数

    // 映射到目标范围
    const normalized = uint32 / 0xFFFFFFFF; // 归一化为 [0, 1) 的浮点数
    return Math.floor(normalized * range) + min;
}

export function ToInt(str: string): number {
    if (!str || str == "") {
        return 0;
    }
    return parseInt(str);
}

export function ToFloat(str: string): number {
    if (!str || str == "") {
        return 0;
    }
    return parseFloat(str);
}

export function ToNumber(str: string): number {
    if (!str || str == "") {
        return 0;
    }
    return Number(str);
}

export function ToAmt(amt: number): number {
    if (!amt) {
        return 0;
    }
    return ToNumber(amt.toFixed(2))
}

export function RndNumber(len: number = 8): number {
    const min = Math.pow(10, len - 1);
    const max = Math.pow(10, len) - 1;
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function BuildID(id: string): number {
    return RndNumber(8).toString() + id;
}

//计算两个坐标之间的直接距离
// longitude 对应系统里的X
// latitude 对应系统里的Y
export function CalcDistance(longitude1: number, latitude1: number, longitude2: number, latitude2: number): number {
    const La1: number = latitude1 * Math.PI / 180.0;
    const La2: number = latitude2 * Math.PI / 180.0;
    const La3: number = La1 - La2;
    const Lb3: number = longitude1 * Math.PI / 180.0 - longitude2 * Math.PI / 180.0;
    let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(La3 / 2), 2) + Math.cos(La1) * Math.cos(La2) * Math.pow(Math.sin(Lb3 / 2), 2)));
    s = s * 6378.137;
    s = Math.round(s * 10000) / 10000;
    s = s.toFixed(2);
    return s;
}

//截取字符串
export function CutText(text: string, maxChars: number, ellipsis: string = "..."): string {
    return text.length > maxChars ? text.slice(0, maxChars) + ellipsis : text;
}

export function HideMobile(mobile: string): string {
    if (!mobile) {
        return "";
    } else if (mobile.length <= 7) {
        return mobile.substring(0, 3) + "****" + mobile.substring(mobile.length - 3);
    } else if (mobile.length <= 11) {
        return mobile.substring(0, 3) + "****" + mobile.substring(mobile.length - 4);
    } else {
        return mobile.substring(0, 3) + "****" + mobile.substring(mobile.length - 4);
    }
}